import React from "react";
import "./Ten_Years.css";
import Blue_Outline_Btn from "../../common_components/common_btn/blue_outline_btn/Blue_Outline_Btn";
import { useNavigate } from "react-router-dom";

const Ten_Years = () => {
  const nevigate = useNavigate();
  return (
    <section className="Ten_Years">
      <div className="container">
        <div className="content_div">
          <div className="left_div">
            <p className="bold_text">10+ Years</p>
            <p className="subtext">As Sleep Experts</p>

            <div className="blue_div">
              <p className="text">
                For over 10 years, we’ve been the secret behind quality sleep
                for businesses worldwide. Driven by integrity and fueled by
                innovation, we don’t just sell furniture - we craft tailored
                sleep solutions designed to help your business (and your guests)
                rest easy.
              </p>
            </div>

            <div className="btn_holder">
              <Blue_Outline_Btn btnText={"EXPLORE"} onClick={()=>nevigate('/about-us')} />
            </div>
          </div>

          <div className="right_img_div">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/home/ten_years/img.png"
              }
              className="right_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ten_Years;
